import { makeAutoObservable, runInAction } from 'mobx';

export enum TabKeys {
  details = 'details',
  orgLinking = 'orglinking',
  vendorLinking = 'vendorlinking',
  users = 'users',
  payments = 'payments',
  paymentsRequests = 'paymentsRequests',
  debug = 'debug',
  orgSanctions = 'orgSanctions',
  vendorSanctions = 'vendorSanctions'
}

export enum DetailsTabRubrics {
  tagging = 'tagging',
  organization = 'organization',
  vendor = 'vendor',
  ip = 'ip',
  fundingSource = 'fundingSource',
  deliveryMethod = 'deliveryMethod',
  payment = 'payment',
  comments = 'comments'
}

class InboxDrawerStore {
  activeKey?: TabKeys;

  activeRubricId?: DetailsTabRubrics | string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setActiveKey = (key: TabKeys) => {
    runInAction(() => {
      this.activeKey = key;
    });
  };

  setActiveRubricId = (rubricId: DetailsTabRubrics | string | null) => {
    runInAction(() => {
      this.activeRubricId = rubricId;
    });
  };
}

export default new InboxDrawerStore();
